{
  "de": {
    "pupilProjectStatus": {
      "switchError": "Fehler beim Projektwechsel",
      "switchModal": {
        "joinAnotherClassroom": "Ausloggen und Klassenraum wechseln",
        "loading": "Verfügbare Projekte werden geladen...",
        "noOtherProjects": "In diesem Klassenraum sind keine anderen Projekte verfügbar.",
        "selectProject": "Deine Inhalte werden in diesem Projekt gespeichert:",
        "selectProjectPlaceholder": "Wähle ein Projekt zum Wechseln",
        "title": "Projekt Zuordnung"
      },
      "changeProject": "Projekt wechseln",
      "logoutError": "Fehler beim Logout",
      "switchSuccess": "Projekt erfolgreich gewechselt"
    }
  }
}
